import { Navigate, useLocation, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useCompetenciesFeatures } from 'modules/competencies/hooks/useCompetenciesFeatures'

const CompetencyPageRedirect = () => {
  const { competencyId } = useParams()
  const { navigation } = useNavigation()
  const location = useLocation()
  const { isJobCatalogTreeEnabled } = useCompetenciesFeatures()

  const redirectPath = isJobCatalogTreeEnabled
    ? navigation.competencies.competencyId.levels
    : navigation.competencies.competencyId.settings

  return (
    <Navigate
      replace
      to={{
        pathname: redirectPath.fullPath({ competencyId: Number(competencyId) }),
        search: location.search,
      }}
    />
  )
}

export default CompetencyPageRedirect
